<script>
    import store from '../../../Stores/grupo-store';
    import storeGrupos from '../../../Stores/grupos-store';
    import axios from '../../../axios-control';

    import {createEventDispatcher} from 'svelte';
    const dispatch = createEventDispatcher();

    import {validaGrupo} from '../../../Modelos/Grupo';

    import Caja from "../../UI/Caja.svelte";
    import Subtitulo from "../../UI/Subtitulo.svelte";
    import CampoDeTexto from "../../UI/CampoDeTexto.svelte";
    import Boton from "../../UI/Boton.svelte";
    import CampoDeSeleccion from "../../UI/CampoDeSeleccion.svelte";
    import {creaOpciones} from "../../../Utils/selects";

    let grupo, error, errores;
    $: grupo = $store.grupo;
    $: errores = validaGrupo(grupo);
    $: error = $store.error;

    $: grupos = $storeGrupos.listado;
    $: opcionesDeGrupo = creaOpciones(grupos);

    let estadoInicial;
    $: estadoInicial = estadoInicial || $store.grupo;

    let sucio = false;
    $: sucio = JSON.stringify(estadoInicial) !== JSON.stringify($store.grupo);

    const actualizaCampo = (campo, valor) => store.actualizaCampo(campo, valor);

    const enviaFormulario = e => {
        e.preventDefault();
        estadoInicial = null;
        store.guarda().then(() => storeGrupos.cargar()).then(() => dispatch('enviado'));
    };
</script>

<style>
    @media (min-width: 1024px) {
        .fila {
            display: grid;
            grid-template-columns: 1fr 1fr;
            grid-gap: var(--padding-global);
        }

        .fila-3 {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            grid-gap: var(--padding-global);
        }
    }
</style>

<Caja>
    <div slot="titulo">
        <Subtitulo>
            {grupo.nombre}
        </Subtitulo>
    </div>

    <form on:submit={enviaFormulario}>
        <div class="fila">
            <CampoDeTexto id="nombre" label="Nombre" value={grupo.nombre}
                          icono="scatter_plot" valido={!errores.nombre}
                          mensajeDeError={errores.nombre} disabled={grupo.protegido}
                          on:input={e => actualizaCampo('nombre', e.target.value)}/>

            <CampoDeSeleccion id="padre" label="Padre" value={grupo.padre}
                              icono="arrow_upward" valido={true}
                              opciones={opcionesDeGrupo}
                              on:input={e => actualizaCampo('padre', e.target.value)}/>
        </div>
    </form>

    <div slot="pie">
        <Boton on:click={enviaFormulario} type="submit"
               disabled={!sucio || Object.keys(errores).length}>
            Guardar
        </Boton>
    </div>
</Caja>